// Simple storage to reduce requests for Job Info
// TODO: Move to a proper store e.g. NgRx

import { IJobDeployment } from '../interfaces/job-deployment';
import { Injectable } from '@angular/core';
import { IInboxJob } from '../interfaces/inbox-job';
import { ISupplier } from '../interfaces/supplier';
import { SupplierCard } from '../interfaces/supplier-card';

@Injectable({ providedIn: 'root' })
export class JobStorageService {
  private jobDeployments: Record<string, IJobDeployment> = {};

  private inboxJobs: Record<string, IInboxJob> = {};

  private suppliers: Record<string, SupplierCard> = {};

  public setSupplier(id: number, supplier: SupplierCard) {
    window.localStorage.setItem(`JobStorageServiceSupplier${id}`, JSON.stringify(supplier));
    this.suppliers[id] = supplier;
  }

  public getSupplier(id: number): SupplierCard {
    if (!this.suppliers[id]) {
      let stored = window.localStorage.getItem(`JobStorageServiceSupplier${id}`);
      return stored ? JSON.parse(stored) : null;
    }
    return this.suppliers[id];
  }

  public setJobDeployment(id: number, job: IJobDeployment) {
    window.localStorage.setItem(`JobStorageServiceJobDeployment${id}`, JSON.stringify(job));
    this.jobDeployments[id] = job;
  }

  public getJobDeployment(id: number): IJobDeployment {
    if (!this.jobDeployments[id]) {
      let stored = window.localStorage.getItem(`JobStorageServiceJobDeployment${id}`);
      return stored ? JSON.parse(stored) : null;
    }
    return this.jobDeployments[id];
  }

  public setInboxJob(id: number, job: IInboxJob) {
    window.localStorage.setItem(`JobStorageServiceInboxJob${id}`, JSON.stringify(job));
    this.inboxJobs[id] = job;
  }

  public getInboxJob(id: number): IInboxJob {
    if (!this.inboxJobs[id]) {
      let stored = window.localStorage.getItem(`JobStorageServiceInboxJob${id}`);
      return stored ? JSON.parse(stored) : null;
    }
    return this.inboxJobs[id];
  }
}
